<template>
    <div :item="socketMessage" style="font-size:1rem;cursor:pointer;color:#409EFF;z-index:9999;position:fixed;bottom:10px;right:10px;width:200px;background:#fafafa;border:1px solid #dedede;padding:1rem 1rem;" v-if="showMessage" @click="checkMessage">
      您有一条未读消息！
    </div>
</template>

<script>
let origin = window.location.hostname;
let wyFlag = false;
  import {mapGetters} from "vuex";
  import dayjs from 'dayjs';
import {getMessageList,getMessageDetail} from "@/api/message/message";
export default {
    data() {
      // let userId = this.userInfo.user_id;
      // console.log(this.userInfo.user_id);
      return {
        abnormalCounter:0,
        socketTimestamp:'',
        intervalController:'',
        socketMessage:'',
        showMessage:false,
        wsMsg:'',
        path:``,
            socket:"",
        activeNames: ['1', '2', '3', '5'],
        logActiveNames: ['17']
      };
    },
    mounted () {
      let self = this;
      // 默认需要消息通知，不需要的域名在if里配置
        if(origin.indexOf('xxx')>-1){
          wyFlag = true;
        }else{
          wyFlag = false;
        }
        if(!wyFlag){
          window.onunload = ()=>{
            console.log("this.socket====>onunload=====>",this.socket);
            localStorage.setItem('closeAction','closeAction')
            localStorage.setItem('this.socket',this.socket)
            this.socket.onclose = this.closeAction();
            this.socket.close();
            clearInterval(self.intervalController);
            // localStorage.setItem('closeTag','closeTag');
          }
          if(this.userInfo){
            console.log('----------------top-bar!----------------');
              this.wsConnectHandler();
          }
        }

    },
    destroyed () {
        if(!wyFlag){
          // 销毁监听
          // console.log('8888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888');
          localStorage.setItem('closeDestroyTag','closeDestroyTag');
          this.socket.onclose = this.closeAction();
          this.socket.close();
            clearInterval(this.intervalController);
        }
    },
    computed: {
      ...mapGetters(["userInfo"]),
    },
    beforeRouteLeave(to, from, next){
      if(to.path=='/login'){ //当前页面路由
        if(!wyFlag){
          console.log("=============closeDestroyTag");
          // 销毁监听
          // console.log('8888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888');
          localStorage.setItem('closeDestroyTag','closeDestroyTag');
          this.socket.onclose = this.closeAction();
          this.socket.close();
            clearInterval(this.intervalController);
        }
        next();
            // next({replace: true,redirect: '/a'}); //目标路由 重定向
      }else {
            next()
      }
    },
    methods: {
      closeAction(){
                console.log('websocket closed!');
      },
      checkMessage(e){
        this.showMessage = false;
        this.$emit('checkMessageClose');
      },
      wsConnectHandler(){
        this.init()
      },
      sendMsg(){

        // this.send(this.wsMsg);
        var heartBeat = {
          data: 'heartbeat',
          eventType: 'HEARTBEAT',
          time: new Date().getTime()
        };
        this.send(JSON.stringify(heartBeat));
      },
              init: function () {
                clearInterval(this.intervalController);
                // this.path = `ws://localhost:1888/ws/v4ward/websocket/example?userId=${this.userInfo.user_id}`;
                if(localStorage.getItem('lostSessionKey')){
                  let lostSessionKey = localStorage.getItem('lostSessionKey');
                  if(window.location.protocol.indexOf('https')>-1){                    
                    this.path = 'wss://'+window.location.host+`/ws/v4ward/websocket/example?userId=${this.userInfo.user_id}&lostSessionKey=${lostSessionKey}`;

                  }else{

                    this.path = 'ws://'+window.location.host+`/ws/v4ward/websocket/example?userId=${this.userInfo.user_id}&lostSessionKey=${lostSessionKey}`;
                  }
                }else{
                  if(window.location.protocol.indexOf('https')>-1){                 
                  this.path = 'wss://'+window.location.host+`/ws/v4ward/websocket/example?userId=${this.userInfo.user_id}`;
                  }else{
                  this.path = 'ws://'+window.location.host+`/ws/v4ward/websocket/example?userId=${this.userInfo.user_id}`;
                  }
                }
            if(typeof(WebSocket) === "undefined"){
                alert("您的浏览器不支持socket")
            }else{
                // 实例化socket
                this.socket = new WebSocket(this.path)
                // 监听socket连接
                this.socket.onopen = this.open
                // 监听socket错误信息
                this.socket.onerror = this.error
                // 监听socket消息
                this.socket.onmessage = this.getMessage

            }
        },
        open: function () {
            console.log("socket连接成功")
            console.log("this.socket====>",this.socket);
            this.intervalController = setInterval(() => {
              this.sendMsg('WebSocket connecting...')
              setTimeout(() => {
                let remainSeconds = dayjs(new Date().getTime()).diff(dayjs(this.socketTimestamp),'seconds');
                if(remainSeconds>15){
                  this.abnormalCounter = this.abnormalCounter+1;
                  if(this.abnormalCounter == 3){
                    this.abnormalCounter = 0;
                    this.init();
                  }
                }else{
                  this.abnormalCounter = 0;
                }
              }, 10000);
            },30000);
        },
        error: function () {
            console.log("连接错误")
            setTimeout(() => {
              this.init();
            }, 30000);
        },
        getMessage: function (msg) {
          let messageInfo = JSON.parse(msg.data);

          if(messageInfo.eventType === 'HEARTBEAT'){
            console.log('服务器应答心跳信息');
          } else if(messageInfo.eventType === 'NOTIFY_MSG') {
            console.log('业务通知消息');
            this.showMessage = true;
          } else if(messageInfo.eventType === 'SESSION_KEY'){
            console.log('session:' + messageInfo.data);
            localStorage.setItem('lostSessionKey',messageInfo.data);
          } else if(messageInfo.eventType === 'TEST'){
            console.log('测试消息:' + messageInfo.data);
          } else {
            console.log('未知类型：' + messageInfo.eventType);
          }
          this.socketTimestamp = messageInfo.time;
          this.socketMessage = messageInfo.data;
        },
        send: function (params) {
            this.socket.send(params)
        },
        close: function () {
            console.log("socket已经关闭")
        },
      handleChange(val) {
        window.console.log(val);
      }
    },
}
</script>

<style>

</style>
